var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, Typography } from '@mui/material';
import { usePreviewLoop } from 'hx-din-test-2';
import { StepLayout } from '../step-layout.component';
import { pageImages } from '@/pages/images';
import { VolumeSelectContent } from './volume-select-content.component';
import { useSendButtonClick } from '@/hooks/use-send-button-click.hook';
export function VolumeSelect() {
    var state = usePreviewLoop().dinPlayer.state;
    var handleSendButtonClick = useSendButtonClick().handleSendButtonClick;
    if (state.status === 'initializing')
        return (_jsx("div", __assign({ className: "grid w-full h-full place-items-center" }, { children: _jsx(CircularProgress, {}) })));
    return (_jsx(StepLayout, { image: pageImages.norcVolumeSetting, heading: _jsx(Typography, __assign({ variant: "h2", className: "md:text-4xl text-3xl leading-10 mb-4" }, { children: "Adjust the volume to a comfortable listening level." })), progress: {
            phase: 0,
            step: 5,
        }, content: _jsx(VolumeSelectContent, {}) }));
}
